import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import { IAfeAssetDetail, IAfeBranchAddressDetails, IAFERequest } from "Model/IAFEReClassification";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { formatPrice } from "utils";

const convertBooleanToYesNo = (value: boolean | null): { key: string; text: string } | null => {
  if (value === null) return null;
  return value ? { key: "Yes", text: "Yes" } : { key: "No", text: "No" };
};

const createAfeAssetDetail = (assetData: any): IAfeAssetDetail => {
  const isRepairValueOver1500 = assetData?.isRepairValueOver1500 === null
    ? null
    : convertBooleanToYesNo(assetData.isRepairValueOver1500);

  return {
    assetNumber: assetData?.assetNumber,
    unitNumber: assetData?.unitNumber,
    eqStatus: assetData?.eqStatus,
    eqClass: assetData?.eqClass,
    year: assetData?.year,
    description: assetData?.description,
    color: assetData?.color,
    vinSerialNumber: assetData?.vinSerialNumber,
    licenseNumber: assetData?.licenseNumber,
    netBookedValue: assetData?.netBookedValue ? formatPrice(assetData.netBookedValue, 2) : "0.00",
    cost: assetData?.cost ? formatPrice(assetData.cost, 2) : "0.00",
    invoicedAmount: assetData?.invoicedAmount ? formatPrice(assetData.invoicedAmount, 2) : "0.00",
    jeDescription: assetData?.jeDescription,
    leaseId: assetData?.leaseId,
    leaseExpirationDate: assetData?.leaseExpirationDate ? new Date(assetData.leaseExpirationDate) : null,
    isRepairRequest: convertBooleanToYesNo(assetData?.isRepairRequest),
    isRepairValueOver1500: isRepairValueOver1500,
    isEfficiencyIncreased: convertBooleanToYesNo(assetData?.isEfficiencyIncreased),
    isLifeExtendedOneYear: convertBooleanToYesNo(assetData?.isLifeExtendedOneYear),
    branchAddressDetail: assetData?.branchAddressDetail
  };
};

const ReactToAPI = (props: any) => {

  const {
    afeAssetDetailData,
    afeReClassificationData,
    afeBranchAddressDetail,
    dispatch,
    docList,
    clickType
  } = props;

  const apiObject: IAFERequest = {
    orderId: afeReClassificationData?.orderId,
    orderType: afeReClassificationData?.orderType,
    orderTypeId: afeReClassificationData?.orderTypeId,
    branchId: afeReClassificationData?.branchId,
    costCenterNo: afeReClassificationData?.costCenterNo,
    costCenterName: afeReClassificationData?.costCenterName,
    userEmailId: afeReClassificationData?.userEmailId,
    savedBy: afeReClassificationData?.savedBy,
    orderAction: clickType,
    attachments: docList,
    isApprovalOverride: afeReClassificationData?.isApprovalOverride,
    afeDetail: {
      branchValue: afeReClassificationData?.afeDetail?.branchValue,
      afeType: afeReClassificationData?.afeDetail?.afeTypeId,
      afeDetailId: afeReClassificationData?.afeDetail?.afeDetailId,
      itemNumber: 1,
      afeTypeId: afeReClassificationData?.afeDetail?.afeType,
      quantity: 1,
      attachments: docList,
      afeAssetDetail: {
        assetNumber: afeAssetDetailData?.assetNumber,
        unitNumber: afeAssetDetailData?.unitNumber ?? null,
        eqStatus: afeAssetDetailData?.eqStatus ?? null,
        eqClass: afeAssetDetailData?.eqClass ?? null,
        year: afeAssetDetailData?.year ?? null,
        description: afeAssetDetailData?.description ?? null,
        color: afeAssetDetailData?.color ?? null,
        vinSerialNumber: afeAssetDetailData?.vinSerialNumber ?? null,
        licenseNumber: afeAssetDetailData?.licenseNumber ?? null,
        netBookedValue: afeAssetDetailData?.netBookedValue ? getOnlyNumbers(afeAssetDetailData?.netBookedValue) : "0.00",
        cost: afeAssetDetailData?.cost ? getOnlyNumbers(afeAssetDetailData?.cost) : "0.00",
        invoicedAmount: afeAssetDetailData?.invoicedAmount ? getOnlyNumbers(afeAssetDetailData?.invoicedAmount) : "0.00",
        jeDescription: afeAssetDetailData?.jeDescription,
        leaseId: afeAssetDetailData?.leaseId ?? null,
        leaseExpirationDate: afeAssetDetailData?.leaseExpirationDate ?? null,
        isRepairRequest: afeAssetDetailData?.isRepairRequest?.key == 'Yes' ? true : afeAssetDetailData?.isRepairRequest?.key == 'No' ? false : null,
        isRepairValueOver1500: afeAssetDetailData?.isRepairValueOver1500?.key == 'Yes' ? true : afeAssetDetailData?.isRepairValueOver1500?.key == 'No' ? false : null,
        isEfficiencyIncreased: afeAssetDetailData?.isEfficiencyIncreased?.key == 'Yes' ? true : afeAssetDetailData?.isEfficiencyIncreased?.key == 'No' ? false : null,
        isLifeExtendedOneYear: afeAssetDetailData?.isLifeExtendedOneYear?.key == 'Yes' ? true : afeAssetDetailData?.isLifeExtendedOneYear?.key == 'No' ? false : null,
        branchAddressDetail: {
          addLine1: afeBranchAddressDetail?.addLine1,
          addLine2: afeBranchAddressDetail?.addLine2,
          assetCity: afeBranchAddressDetail?.assetCity,
          assetState: afeBranchAddressDetail?.assetState,
          assetZip: afeBranchAddressDetail?.assetZip
        }
      }
    }
  }
  dispatch(TransferAction.getSaveAfeReClassification(apiObject));
};

const ApiToReact = (props: any) => {
  const {
    afeOrderByIdData,
    dispatch,
    UploadAttachmentsDispatch,
    Moment
  } = props

  if (afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail != null) {
    let branchDetailsTemp: IAfeBranchAddressDetails = {
      addLine1: afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail?.addLine1,
      addLine2: afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail?.addLine2,
      assetCity: afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail?.assetCity,
      assetState: afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail?.assetState,
      assetZip: afeOrderByIdData?.afeDetail?.afeAssetDetail?.branchAddressDetail?.assetZip
    }
    dispatch(TransferAction.setAfeBranchAddressDetail(branchDetailsTemp))
  }
  
  if (afeOrderByIdData?.afeDetail?.afeAssetDetail != null) {
    const afeAssetDetailTemp = createAfeAssetDetail(afeOrderByIdData.afeDetail.afeAssetDetail);
    dispatch(TransferAction.setAfeAssetDetailData(afeAssetDetailTemp))
  }
  
  let afeReClassificationDataTemp: any = {
    orderId: afeOrderByIdData?.orderId,
    orderType: afeOrderByIdData?.orderRequestType,
    orderTypeId: afeOrderByIdData?.orderRequestTypeId,
    branchId: afeOrderByIdData?.branchId,
    costCenterNo: afeOrderByIdData?.costCenter?.split('-')[0],
    costCenterName: afeOrderByIdData?.costCenter?.split('-')[1],
    userEmailId: afeOrderByIdData?.createdBy,
    requestedBy: afeOrderByIdData?.requestedBy,
    savedBy: afeOrderByIdData?.requestedBy,
    isApprovalOverride: afeOrderByIdData?.isApprovalOverride,
    afeDetail: {
      branchValue: afeOrderByIdData?.branchName,
      afeTypeId: afeOrderByIdData?.afeDetail?.afeType,
      afeDetailId: afeOrderByIdData?.afeDetail?.afeDetailId,
      itemNumber: 1,
      afeType: afeOrderByIdData?.afeDetail?.afeTypeId,
      quantity: 1,
      isBranchSplit: afeOrderByIdData?.afeDetail?.isBranchSplit ? "Yes" : "No",
      attachments: afeOrderByIdData?.attachments
    }
  }
  dispatch(TransferAction.setAfeReClassificationData(afeReClassificationDataTemp));

  let currentBranch = {
    branchNo: afeOrderByIdData?.branchId,
    branchName: afeOrderByIdData?.branchName,
    value: afeOrderByIdData?.costCenter,
    label: afeOrderByIdData?.costCenter,
    text: afeOrderByIdData?.branchId,
    costCenter: afeOrderByIdData?.costCenter.split('-')[0].trim(),
  }
  dispatch(TransferAction.setSelectedBranch(currentBranch));

  let orderAttachment = afeOrderByIdData?.orderAttachments?.length > 0 ? JSON.parse(JSON.stringify(afeOrderByIdData?.orderAttachments)) : [];
  UploadAttachmentsDispatch.dispatchSetAttachments(dispatch)(orderAttachment);
}

export {
  ReactToAPI,
  ApiToReact
}